export const GLOBAL_ENVIRONMENT = Object.freeze({
  develop: 'development',
  test: 'test',
  stage: 'stage',
  prod: 'prod',
})
